import ScaleOutlined from "@mui/icons-material/ScaleOutlined";

import { makeSvgIcon } from "./svg-icon";

export const ScaleIcon = makeSvgIcon(ScaleOutlined);

export default ScaleIcon;
